import { useEffect, useState } from 'react';

/**
 * When true (default), lesson steps with narration try to play audio after load.
 * User can turn off in Settings → Learner. Stored in localStorage (no backend).
 */
const STORAGE_KEY = 'explore-lesson-narration-autoplay-v1';

const listeners = new Set();

function emit() {
  listeners.forEach((fn) => fn());
}

/** @returns {boolean} */
export function loadLessonNarrationAutoplay() {
  if (typeof window === 'undefined') return true;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw === null) return true;
    return raw === '1' || raw === 'true';
  } catch {
    return true;
  }
}

/** @param {boolean} enabled */
export function setLessonNarrationAutoplay(enabled) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, enabled ? '1' : '0');
  } catch {
    /* quota / private mode */
  }
  emit();
}

/** @param {() => void} cb @returns {() => void} */
export function subscribeLessonNarrationAutoplay(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

/**
 * @returns {[boolean, (enabled: boolean) => void]}
 */
export function useLessonNarrationAutoplay() {
  const [autoplay, setState] = useState(() => loadLessonNarrationAutoplay());
  useEffect(() => subscribeLessonNarrationAutoplay(() => setState(loadLessonNarrationAutoplay())), []);
  return [autoplay, setLessonNarrationAutoplay];
}
